import { render, staticRenderFns } from "./two.vue?vue&type=template&id=25a177e8&scoped=true&"
import script from "./two.vue?vue&type=script&lang=js&"
export * from "./two.vue?vue&type=script&lang=js&"
import style0 from "./two.vue?vue&type=style&index=0&id=25a177e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a177e8",
  null
  
)

export default component.exports